import React from "react";

const CommonCheckBox = ({
  isChecked,
  width = window?.innerWidth <= 768 ?  "18px" : "28px",
  height = window?.innerWidth <= 768 ?  "18px" : "28px",
  onChange,
  register,
  name,
  // markactive,
  isMember,
  isMarkactive = false,
}) => {
  return (
    <input
      className="custom-checkbox"
      style={{
        width: width,
        height: height,
        borderRadius: "4px",
        cursor: "pointer",
        border: isMember ? "1px solid #83BD56" : "1px solid #367bbf",
        // accentColor: markactive ? "#83BD56" : isMember ? "#83BD56" : "#367bbf",
        background: "white !important",
      }}
      type="checkbox"
      checked={isChecked}
      onChange={onChange}
      ref={register}
      name={name}
    />
  );
};

export default CommonCheckBox;
